"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineToEmailObject = void 0;
const dayjs = require("dayjs");
const calculateCaddies_1 = require("./calculateCaddies");
const calculateCarts_1 = require("./calculateCarts");
const calculateGolfTotalCostValue_1 = require("./calculateGolfTotalCostValue");
const calculateGolfTotalSellValue_1 = require("./calculateGolfTotalSellValue");
const calculateTransferTotalCostValue_1 = require("./calculateTransferTotalCostValue");
const calculateTransferTotalSellValue_1 = require("./calculateTransferTotalSellValue");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineToEmailObject = (order_line, linked_order_line) => {
    if (!order_line.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(order_line.versions);
    if (!latest_version)
        return null;
    const latest_linked_version = linked_order_line && linked_order_line.versions
        ? (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(linked_order_line.versions)
        : null;
    const obj = {
        id: order_line.id,
        status: latest_version.status,
    };
    const getTransferType = (type) => {
        switch (type) {
            case "ONE_WAY":
                return "One Way";
            case "RETURN":
                return "Return";
            case "CUSTOM":
                return "Custom";
            default:
                return "";
        }
    };
    const getDetailSummary = (config) => {
        const destinations = [];
        switch (config.where_when_who.type) {
            case "ONE_WAY":
            case "RETURN":
                destinations.push(config.transfer_legs.outbound.from_name);
                destinations.push(config.transfer_legs.outbound.to_name);
                break;
            case "CUSTOM":
                destinations.push(config.transfer_legs.outbound.from_name);
                destinations.push(config.transfer_legs.outbound.to_name);
                destinations.push(config.transfer_legs.inbound.to_name);
                break;
        }
        return destinations.join(" > ");
    };
    switch (order_line.type.toLowerCase()) {
        case "golf": {
            const golf_config = latest_version.config;
            const caddie_extras = golf_config.caddies.enabled
                ? `${golf_config.where_when_who.number_of_golfers} x ${golf_config?.caddies?.type === "SINGLE_CADDIE"
                    ? "Single Caddies"
                    : "Shared Caddies"} ${` (${golf_config.supplier.currency} ${(0, calculateCaddies_1.calculateCaddies)(golf_config)}${golf_config.caddies?.payment_option === "ON_ARRIVAL"
                    ? " - pay at course"
                    : ""})`}`
                : "";
            const cart_extras = golf_config.carts.enabled
                ? golf_config?.carts?.types
                    ? golf_config?.carts?.types
                        .filter((type) => type.quantity > 0)
                        .map((type) => {
                        return `${type.quantity} x ${type.type === "SINGLE_CART" ? "Single Cart" : "Shared Cart"} ${` (${golf_config.supplier.currency} ${(0, calculateCarts_1.calculateCarts)(golf_config)}${golf_config.carts?.payment_option === "ON_ARRIVAL"
                            ? " - pay at course"
                            : ""})`}`;
                    })
                        .join(", ")
                    : ""
                : "";
            return {
                ...obj,
                golf: {
                    pricing_summary: {
                        per_person: (0, calculateGolfTotalSellValue_1.calculateGolfTotalSellValue)(golf_config) /
                            golf_config.where_when_who.number_of_golfers,
                        per_person_cost: (0, calculateGolfTotalCostValue_1.calculateGolfTotalCostValue)(golf_config) /
                            golf_config.where_when_who.number_of_golfers,
                        green_fee: (golf_config?.green_fee?.cost + golf_config?.green_fee?.margin) *
                            golf_config?.where_when_who?.number_of_golfers +
                            Number(golf_config?.where_when_who.number_of_golfers % 2
                                ? golf_config?.green_fee?.surcharge || 0
                                : 0),
                        green_fee_cost: golf_config?.green_fee?.cost *
                            golf_config?.where_when_who?.number_of_golfers +
                            Number(golf_config?.where_when_who.number_of_golfers % 2
                                ? golf_config?.green_fee?.surcharge || 0
                                : 0),
                        carts: (0, calculateCarts_1.calculateCarts)(golf_config),
                        caddies: (0, calculateCaddies_1.calculateCaddies)(golf_config),
                        total: (0, calculateGolfTotalSellValue_1.calculateGolfTotalSellValue)(golf_config),
                        total_cost: (0, calculateGolfTotalCostValue_1.calculateGolfTotalCostValue)(golf_config),
                    },
                    supplier: {
                        name: golf_config.supplier.name,
                        currency: golf_config.supplier.currency,
                    },
                    extras: {
                        hasExtras: caddie_extras !== "" ||
                            cart_extras !== "" ||
                            golf_config?.green_fee?.rate_note !== "",
                        note: golf_config?.green_fee?.rate_note,
                        caddies: caddie_extras,
                        carts: cart_extras,
                    },
                    note: golf_config.voucher_notes,
                    tee_time: {
                        ...golf_config.tee_time,
                        groups: golf_config.tee_time.groups.map((group, idx) => {
                            return {
                                ...group,
                                id: idx + 1,
                            };
                        }),
                    },
                    caddies: {
                        enabled: golf_config.caddies.enabled,
                        summary: caddie_extras,
                    },
                    carts: {
                        enabled: golf_config.carts.enabled,
                        summary: cart_extras,
                    },
                    where_when_who: {
                        date: dayjs(golf_config.where_when_who.date).format("dddd, MMMM D, YYYY"),
                        number_of_golfers: golf_config.where_when_who.number_of_golfers,
                    },
                    product: {
                        name: golf_config.product.name,
                    },
                    course: {
                        name: golf_config.course.name,
                    },
                },
            };
        }
        case "hotel":
            return {
                ...obj,
                hotel: {},
            };
        case "transfer": {
            const transfer_config = latest_version.config;
            const linked_golf_line = latest_linked_version
                ? latest_linked_version.config
                : null;
            if (linked_golf_line) {
                console.log(`LINKED GOLF LINE: ${JSON.stringify(linked_golf_line)}`);
            }
            let email_obj = {
                ...obj,
                transfer: {
                    pricing_summary: {
                        per_person: (0, calculateTransferTotalSellValue_1.calculateTransferTotalSellValue)(transfer_config) /
                            transfer_config.where_when_who.number_of_passengers,
                        per_person_cost: (0, calculateTransferTotalCostValue_1.calculateTransferTotalCostValue)(transfer_config) /
                            transfer_config.where_when_who.number_of_passengers,
                        total: (0, calculateTransferTotalSellValue_1.calculateTransferTotalSellValue)(transfer_config),
                        total_cost: (0, calculateTransferTotalCostValue_1.calculateTransferTotalCostValue)(transfer_config),
                    },
                    supplier: {
                        name: transfer_config.supplier.name,
                        currency: transfer_config.supplier.currency,
                    },
                    detail_summary: getDetailSummary(transfer_config),
                    where_when_who: {
                        date: dayjs(transfer_config.where_when_who.date).format("dddd, MMMM D, YYYY"),
                        type: getTransferType(transfer_config.where_when_who.type),
                        number_of_passengers: transfer_config.where_when_who.number_of_passengers,
                        pickup_name: transfer_config.where_when_who.pickup_name,
                    },
                    note: transfer_config.voucher_notes,
                    outbound: {
                        fromDetailsSet: transfer_config.transfer_legs.outbound.from_details !== null,
                        toDetailsSet: transfer_config.transfer_legs.outbound.to_details !== null,
                        isFromAirport: transfer_config.transfer_legs.outbound.from_type === "Airport",
                        isFromArea: transfer_config.transfer_legs.outbound.from_type === "Area",
                        isFromCourse: transfer_config.transfer_legs.outbound.from_type === "Course",
                        isToAirport: transfer_config.transfer_legs.outbound.to_type === "Airport",
                        isToArea: transfer_config.transfer_legs.outbound.to_type === "Area",
                        isToCourse: transfer_config.transfer_legs.outbound.to_type === "Course",
                        ...transfer_config.transfer_legs.outbound,
                    },
                    inbound: {
                        fromDetailsSet: transfer_config.transfer_legs.inbound.from_details !== null,
                        toDetailsSet: transfer_config.transfer_legs.inbound.to_details !== null,
                        isFromAirport: transfer_config.transfer_legs.inbound.from_type === "Airport",
                        isFromArea: transfer_config.transfer_legs.inbound.from_type === "Area",
                        isFromCourse: transfer_config.transfer_legs.inbound.from_type === "Course",
                        isToAirport: transfer_config.transfer_legs.inbound.to_type === "Airport",
                        isToArea: transfer_config.transfer_legs.inbound.to_type === "Area",
                        isToCourse: transfer_config.transfer_legs.inbound.to_type === "Course",
                        ...transfer_config.transfer_legs.inbound,
                    },
                    driver: transfer_config.driver,
                    vehicle: {
                        ...transfer_config.vehicle?.vehicle,
                        quantity: transfer_config.vehicle?.quantity,
                    },
                },
            };
            if (linked_golf_line) {
                const first_tee_time = linked_golf_line.tee_time.groups[0].start_time;
                let recommended_arrival_time = "";
                if (transfer_config.transfer_legs.outbound.to_details !== null &&
                    transfer_config.transfer_legs.outbound.to_type === "Course") {
                    const to_details = transfer_config.transfer_legs.outbound
                        .to_details;
                    recommended_arrival_time = dayjs(linked_golf_line.tee_time.groups[0].start_time, "HH:mm")
                        .subtract(to_details.requested_arrival_time, "minutes")
                        .format("HH:mm");
                }
                email_obj = {
                    ...email_obj,
                    golf: {
                        tee_time: {
                            ...linked_golf_line.tee_time,
                            groups: linked_golf_line.tee_time.groups.map((group, idx) => {
                                return {
                                    ...group,
                                    id: idx + 1,
                                };
                            }),
                        },
                        first_tee_time: first_tee_time,
                        recommended_arrival_time: recommended_arrival_time,
                        where_when_who: {
                            date: dayjs(linked_golf_line.where_when_who.date).format("dddd, MMMM D, YYYY"),
                            number_of_golfers: linked_golf_line.where_when_who.number_of_golfers,
                        },
                        course: {
                            name: linked_golf_line.course.name,
                        },
                        product: {
                            name: linked_golf_line.product.name,
                            config: linked_golf_line.product.config,
                        },
                    },
                };
            }
            return email_obj;
        }
        case "custom":
            return {
                ...obj,
                custom: {},
            };
    }
};
exports.getOrderLineToEmailObject = getOrderLineToEmailObject;
